jQuery(document).ready(function($) {

  // debounce from underscore.js
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  // use x and y mousewheel event data to navigate flickity
  function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
    // do not trigger a slide change if another is being animated
    if (!slick_is_animating) {
      // pick the larger of the two delta magnitudes (x or y) to determine nav direction
      var direction =
          Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

      console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

      if (direction > 0) {
        // next slide
        slick_instance.slick("slickNext");
      } else {
        // prev slide
        slick_instance.slick("slickPrev");
      }
    }
  }

  // debounce the wheel event handling since trackpads can have a lot of inertia
  var slick_handle_wheel_event_debounced = debounce( 
    slick_handle_wheel_event
    , 100, true
  );

  // init slider 
  
  const slick_2 = $(".slides");
  slick_2.slick({
    dots: true,
    vertical: true,
    arrows: false,
    touchMove: false,
    swipe: false,
    infinite: false,
    customPaging: function(slider, i) { 
      return '<button class="tab">' + $(slider.$slides[i]).attr('title') + '<i class="fa fa-sort-asc"></i></button>';
    },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          vertical: false,
        }
      }
    ]
    
  });

  var slick_2_is_animating = false;

  slick_2.on("afterChange", function(index) {
    slick_2_is_animating = false;
  });

  slick_2.on("beforeChange", function(index) {
    slick_2_is_animating = true;
  });


   $prev_arrow = '<div class="slick--prev"><svg width="23px" height="23px" viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="turn-systems-homepage" transform="translate(-981.000000, -2281.000000)" fill="#404040" fill-rule="nonzero"><g id="Group-5" transform="translate(916.000000, 2281.000000)"><g id="Group" transform="translate(65.000000, 0.000000)"><polygon id="Path" points="11.5 0 9.473125 2.026875 17.494375 10.0625 0 10.0625 0 12.9375 17.494375 12.9375 9.473125 20.973125 11.5 23 23 11.5"></polygon></g></g></g></g></svg></div>';
  $next_arrow = '<div class="slick--next"><svg width="23px" height="23px" viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="turn-systems-homepage" transform="translate(-981.000000, -2281.000000)" fill="#404040" fill-rule="nonzero"><g id="Group-5" transform="translate(916.000000, 2281.000000)"><g id="Group" transform="translate(65.000000, 0.000000)"><polygon id="Path" points="11.5 0 9.473125 2.026875 17.494375 10.0625 0 10.0625 0 12.9375 17.494375 12.9375 9.473125 20.973125 11.5 23 23 11.5"></polygon></g></g></g></g></svg></div>';
  
  $(".blog-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: $prev_arrow,
    nextArrow: $next_arrow,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  // function debounce(func, wait, immediate) {
  //   var timeout;
  //   return function() {
  //     var context = this, args = arguments;
  //     var later = function() {
  //       timeout = null;
  //       if (!immediate) func.apply(context, args);
  //     };
  //     var callNow = immediate && !timeout;
  //     clearTimeout(timeout);
  //     timeout = setTimeout(later, wait);
  //     if (callNow) func.apply(context, args);
  //   };
  // };

  // // use x and y mousewheel event data to navigate flickity
  // function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
  //   // do not trigger a slide change if another is being animated
  //   if (!slick_is_animating) {
  //     // pick the larger of the two delta magnitudes (x or y) to determine nav direction
  //     var direction =
  //         Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

  //     console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

  //     if (direction > 0) {
  //       // next slide
  //       slick_instance.slick("slickNext");
  //     } else {
  //       // prev slide
  //       slick_instance.slick("slickPrev");
  //     }
  //   }
  // }

  // // debounce the wheel event handling since trackpads can have a lot of inertia
  // var slick_handle_wheel_event_debounced = debounce( 
  //   slick_handle_wheel_event
  //   , 100, true
  // );

  // // init slider 
  // const slick_3 = $(".washer_slider_outer");
  // slick_3.slick({
  //   dots: true,
  //   vertical: true,
  //   touchMove: false,
  //   swipe: false,
  //   arrows: false,
     
  //   customPaging: function(slider, i) { 
  //     return '<button class="tab">' + $(slider.$slides[i]).attr('title') + '<i class="fa fa-sort-asc"></i></button>';
  //   },
  //   responsive: [
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         vertical: false,
  //       }
  //     }
  //   ]
  // });
  
  // var slick_3_is_animating = false;

  // slick_3.on("afterChange", function(index) {
  //   slick_3_is_animating = false;
  // });

  // slick_3.on("beforeChange", function(index) {
  //   slick_3_is_animating = true;
  // });

  // slick_3.on("wheel", function(e) {
  //   slick_handle_wheel_event_debounced(e.originalEvent, slick_3, slick_3_is_animating);  
  // });

  // $('.washer_slider_thumbnails').on("wheel", function(e) {
  //   slick_handle_wheel_event_debounced(e.originalEvent, slick_3, slick_3_is_animating);  
  // });
  
});

jQuery(document).ready(function() {
  $(document).on("click",".washer_slider_text_content",function(){
    $(this).parent('li').siblings().removeClass('active');
    $(this).parent('li').toggleClass('active');
    var ti = $(this).data("index");
    $( '.washer_slider_outer' ).slick('slickGoTo', ti);

  }); 
  $(document).on("click",".inventry_details_enterprise_icon_text",function(){
    var di = $(this).data("index");
    $( '.slides' ).slick('slickGoTo', di);
    $(this).parents('.inventry_details_enterprise').addClass('active').siblings().removeClass('active');
  }); 
  
  /*$(".how-work-slides--area").slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });*/

}); 


$('#contact_btn_click').on("click",function(){
  $('.custom_body').addClass('custom_body_cng');
  $('.contact_popup_blur').addClass('active');
  $('.contact_popup').fadeIn();
});
$('.submenu-colse').on("click",function(){
  $('.custom_body').removeClass('custom_body_cng'); 
  $('.contact_popup_blur').removeClass('active');
  $('.contact_popup').fadeOut();
});

$('.hubspot_form').on("click",function(e){
   e.preventDefault();
  $('.custom_body').addClass('custom_body_cng');
  $('.contact_popup_blur').addClass('active');
  $('.contact_popup').show();  
});
$('.submenu-colse').on("click",function(){
  $('.custom_body').removeClass('custom_body_cng'); 
  $('.contact_popup_blur').removeClass('active');
  $('.contact_popup').hide();
});  
// var width = $(window).width();
// if (width >991){
//   $(window).on("load",function() {
//     $(window).scroll(function() {
//       var windowBottom = $(this).scrollTop() + $(this).innerHeight();
//       $(".fade_section").each(function() {
//         /* Check the location of each desired element */
//         var objectBottom = $(this).offset().top + $(this).outerHeight();
//         console.log("objectBottom and windowBottom",objectBottom,windowBottom);
//         /* If the element is completely within bounds of the window, fade it in */
//         if (objectBottom > windowBottom) { //object comes into view (scrolling down)
//           if ($(this).css("opacity")==1) {$(this).fadeTo(200,0);}
//         } else { //object goes out of view (scrolling up)
//           if ($(this).css("opacity")==0) {$(this).fadeTo(200,1);}
//         }
//       });
//     }).scroll(); //invoke scroll-handler on page-load
//   });
// }

$(document).ready(function() {
  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
    } else {
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });
  
  $('.article--content').matchHeight();
  // $('.block-title-abt').matchHeight();
  var width = $(window).width();
  
  if (width > 992) {
    
    var max = -1;
    $('.block-title-abt').each(function() {
      var minHeight = $(this).innerHeight();
      max = minHeight > max ? minHeight : max;
    });
    $(".block-title-abt").css('min-height',max);

  } else {
    $('.block-title-abt').matchHeight();
  }
  
  /*var width = $(window).width();
  if (width < 769) {
    $('.product__media-list').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }*/
  
  
  if (width < 992) {
    $('.link-label').click(function(e) {
      e.preventDefault();
      let $this = $(this);
      if ($this.hasClass('show')) {
        $this.removeClass('show');
        $this.next().slideUp(350);
      } else {
        $this.parent().parent().find('.footer-block--menu .link-label').removeClass('show');
        $this.parent().parent().find('.footer-block--menu .linklist-details').slideUp(350);
        $this.toggleClass('show');
        $this.next().slideToggle(350);
      }
    });
    $( ".rounded_plus_minus_icon" ).click(function() {
       $(this).parents('.cover_div').find('.smart_button_hover').toggleClass('active');
      $(this).parents('.cover_div').find('.rounded_plus_minus_icon').toggleClass('active');
        $(this).parents('.blog__post').find('.article-case-study').toggleClass('active'); 
      $(this).parents('.cover_div').find('.smart_button_main .button').html(function(i, text){
      return text.match("Learn") ? "How they use our system" : "Learn More <svg width='572' height='572' viewBox='0 0 572 572' fill='none' xmlns='http://www.w3.org/2000/svg'><g clip-path='url(#clip0_140_3)'><path d='M348.899 52.8279C339.802 43.724 325.044 43.724 315.933 52.8279C306.829 61.9245 306.829 76.6899 315.933 85.7937L492.488 262.349H23.3859C10.4735 262.349 0 272.822 0 285.735C0 298.654 10.4735 309.121 23.3859 309.121H492.254L315.699 485.676C311.319 490.041 308.858 495.981 308.858 502.162C308.858 508.351 311.319 514.276 315.699 518.649C320.078 523.065 326.077 525.512 332.302 525.431C338.506 525.402 344.46 522.97 348.899 518.649L565.209 302.346C569.611 297.937 572.065 291.953 571.999 285.735C571.955 279.531 569.523 273.599 565.209 269.138L348.899 52.8279Z' fill='black'/></g><defs><clipPath id='clip0_140_3'><rect width='572' height='572' fill='white'/></clipPath></defs></svg>";
    });
      });
    
  }
  
});
  $(window).on("load scroll touchmove", function () {
      var items = $(".timeline li"),
      timelineHeight = $(".timeline ul").height(),
      greyLine = $('.default-line'),
      lineToDraw = $('.draw-line');


      // sets the height that the greyLine (.default-line) should be according to .timeline ul height


      // run this function only if draw line exists on the page
      if(lineToDraw.length) {
        $(window).on('scroll', function () {


          // Need to constantly get '.draw-line' height to compare against '.default-line'
          var redLineHeight = lineToDraw.height(),


          greyLineHeight = greyLine.height(),
          windowDistance = $(window).scrollTop(),
          windowHeight = $(window).height() / 2,
          timelineDistance = $(".timeline").offset().top;


          // console.log($(window).height());
          // console.log(windowHeight);
          // console.log(timelineDistance);


          if(windowDistance >= timelineDistance - windowHeight) {
            line = windowDistance - timelineDistance + windowHeight;
            if(line <= greyLineHeight) {
              lineToDraw.css({
                'top' : line  + 'px'
              });
            }
          }
          var bottom = lineToDraw.offset().top + lineToDraw.outerHeight(true);
            items.each(function(index){
              var circlePosition = $(this).offset();
              if(bottom > circlePosition.top) {       
                $(this).addClass('in-view');
              } else {
                $(this).removeClass('in-view');
              }
            }); 
        });
      }
    });
$(document).ready(function() {
// $( "#Details-HeaderMenu-1" ).hover(function(){
//   $(this).find('details').attr("open");
//   $(this).children('summary').attr('aria-expanded', true);
//   });
  $(function() {
  $('#Details-HeaderMenu-1').on('mouseover', function() {
    $(this).attr('open', true);
  }).on('mouseout', function() {
    $(this).attr('open', false);
  })
});
  $( ".trigger1" ).click(function() {
    $(".custom_body" ).addClass('pop_form_op');
    $(".modal").addClass('show-modal');
 });
  $(".close-button").click(function(){
    $(".custom_body" ).removeClass('pop_form_op');
    $(".modal").removeClass('show-modal');
  });
 

  
    });

// const callchildren = document.getElementById("Details-HeaderMenu-1").children;
// function mouseOver() {
//   document.getElementById("Details-HeaderMenu-1").setAttribute("open");
//   document.getElementById("Details-HeaderMenu-1").callchildren.querySelector('summary').setAttribute('aria-expanded', true);
// }

// function mouseOut() {
//   document.getElementById("Details-HeaderMenu-1").removeAttribute("open");
//   document.getElementById("Details-HeaderMenu-1").callchildren.querySelector('summary').removeAttribute('aria-expanded', false);
// }
setTimeout(function() {
  $(".who_uses_turn_inner_title_scrollbar").niceScroll({
    cursorcolor: "#FFA100", // change cursor color in hex
    cursorwidth:3,
    cursoropacitymin:0.4,
    cursorborder:'none',
    cursorfixedheight: 90,
    railalign: "left", // alignment of vertical rail
     background: "rgb(185 185 185)",
    railvalign: "top",
    cursorborderradius:4,
    autohidemode:'leave'
  });
},500);
